import React, {useState} from 'react';
import {
  Popover,
  Box,
  Button,
  CircularProgress,
  Tooltip,
} from '@material-ui/core';
import {Settings, VerticalAlignBottom} from '@material-ui/icons';
import GraphControls from './GraphControls';
import StackedExportDialog from './StackedExportDialog';

const GraphControlsMenu = ({
  onExportXls,
  exportEnabled,
  exportPayload,
  panelChangesLoading = false,
  type,
  ...graphControlsProps
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  const open = Boolean(anchorEl);
  const isChangeLogLoading = type === 'analytics' && panelChangesLoading;

  return (
    <>
      <Box display="flex" alignItems="center" style={{gap: 16}}>
        <Tooltip
          title={isChangeLogLoading ? 'Loading change history…' : ''}
          disableHoverListener={!isChangeLogLoading}
          disableFocusListener={!isChangeLogLoading}
        >
          <Button
            variant="outlined"
            color="default"
            size="small"
            endIcon={
              isChangeLogLoading ? (
                <CircularProgress size={16} color="primary" />
              ) : (
                <Settings color="inherit" />
              )
            }
            aria-haspopup="true"
            aria-expanded={open}
            aria-busy={isChangeLogLoading || undefined}
            onClick={event => setAnchorEl(event.currentTarget)}
          >
            settings
          </Button>
        </Tooltip>
        {onExportXls && (
          <>
            <Button
              variant="outlined"
              color="default"
              size="small"
              disabled={!exportEnabled}
              endIcon={<VerticalAlignBottom />}
              onClick={() => setExportDialogOpen(true)}
            >
              export
            </Button>
            <StackedExportDialog
              open={exportDialogOpen}
              onClose={() => setExportDialogOpen(false)}
              exportPayload={exportPayload}
              onExport={onExportXls}
            />
          </>
        )}
      </Box>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
        transformOrigin={{vertical: 'top', horizontal: 'right'}}
        getContentAnchorEl={null}
        PaperProps={{style: {maxHeight: '70vh', overflowY: 'auto'}}}
      >
        <Box p={3} maxWidth={380} minWidth={280}>
          <GraphControls
            {...graphControlsProps}
            type={type}
            panelChangesLoading={panelChangesLoading}
            layout="column"
          />
        </Box>
      </Popover>
    </>
  );
};

export default GraphControlsMenu;
